import React from "react";
import { useWatch } from "react-hook-form";

import { InputFormField, CheckboxFormField } from "@components/FormField/HookFormFields";
import { i18, trb } from "@utilities";
import { FullWidthInputWrapper, StepperFormRow } from "@components";

export const CompanyFunds = ({ control, handleOtherCheckboxChange }) => {
  const isOther = useWatch({ control, name: "companyFunds.0.data.other" });

  const companyFundsCheckboxes = [
    {
      label: trb(i18.Labels.CompanyFundsShareholderCap),
      value: "shareholderCap"
    },
    {
      label: trb(i18.Labels.CompanyFundsActivityProfit),
      value: "activityProfit"
    },
    { label: trb(i18.Labels.CompanyFundsSaleProperty), value: "saleProperty" },
    { label: trb(i18.Labels.CompanyFundsIncomInvest), value: "incomInvest" },
    { label: trb(i18.Labels.CompanyFundsSubsidies), value: "subsidies" },
    { label: trb(i18.Labels.CompanyFundsBorroving), value: "borroving" },
    { label: trb(i18.Labels.CompanyFundsOther), value: "other" }
  ];

  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-group-title">{trb(i18.Labels.CompanyFunds)}</p>
      </FullWidthInputWrapper>

      {companyFundsCheckboxes.map(checkbox => (
        <FullWidthInputWrapper key={checkbox.value} containerClass="form-step2-checkbox-container">
          <CheckboxFormField
            control={control}
            name={`companyFunds.0.data.${checkbox.value}`}
            label={checkbox.label}
            onChange={checkbox.value === "other" && handleOtherCheckboxChange}
          />
        </FullWidthInputWrapper>
      ))}

      {(isOther === true || isOther === "1") && (
        <FullWidthInputWrapper>
          <InputFormField
            control={control}
            name="companyFunds.0.data.otherInput"
            title={trb(i18.Labels.CompanyFundsOther)}
          />
        </FullWidthInputWrapper>
      )}
    </StepperFormRow>
  );
};
